import React from 'react';

export const InnerLoading = ({ color }) => {
  // inline loading
  return (
    <div className='loading-indicator'>
      <div className='loading-icons'>
        <p style={{ backgroundColor: `${color}` }}></p>
        <p style={{ backgroundColor: `${color}` }}></p>
        <p style={{ backgroundColor: `${color}` }}></p>
        <p style={{ backgroundColor: `${color}` }}></p>
      </div>
    </div>
  );
};
